import AutomationFormPage from './automations/AutomationFormPage';
import AutomationsPage from './automations/AutomationsPage';
import CheckoutPlusSettingsPage from './checkoutPlus/CheckoutPlusSettingsPage';
import CheckoutWidgetSettingsPage from './checkoutPlus/CheckoutWidgetSettingsPage';
import CustomFieldSettingsPage from './customFields/CustomFieldSettingsPage';
import DataExportSettingsFormPage from './dataExport/DataExportSettingsFormPage';
import DataExportSettingsPage from './dataExport/DataExportSettingsPage';
import DeveloperSettingsPage from './developer/DeveloperSettingsPage';
import WebhookDeliveriesPage from './developer/WebhookDeliveriesPage';
import DiscountDefinitionSettingsPage from './discountDefinitions/DiscountDefinitionSettingsPage';
import EmailSettingsPage from './email/EmailSettingsPage';
import IntegrationsSettingsPage from './integrations/IntegrationsSettingsPage';
import MetafieldSettingsPage from './metafields/MetafieldSettingsPage';
import NotificationsSettingsPage from './notifications/NotificationsSettingsPage';
import OrderEditingSettingsPage from './orderEditing/OrderEditingSettingsPage';
import ProductGroupSettingsPage from './productGroups/ProductGroupSettingsPage';
import ClaimReasonSettingsPage from './reasons/ClaimReasonSettingsPage';
import RegistrationSettingsPage from './registrations/RegistrationSettingsPage';
import ReturnsSettingsPage from './returns/ReturnsSettingsPage';
import ShippingProtectionSettingsPage from './shippingClaims/ShippingProtectionSettingsPage';
import ShippingPlusSettingsPage from './shippingPlus/ShippingPlusSettingsPage';
import ShippingPolicySettingsPage from './shippingPolicies/ShippingPolicySettingsPage';
import TagSettingsPage from './tags/TagsSettingsPage';
import TestDriveSettingsPage from './testDrive/TestDriveSettingsPage';
import ThemeSettingsPage from './theme/ThemeSettingsPage';
import TrackingSettingsPage from './tracking/TrackingSettingsPage';
import UserSettingsPage from './users/UserSettingsPage';
import WarrantiesSettingsPage from './warranties/WarrantiesSettingsPage';

export const SettingsPage = {
  Automations: AutomationsPage,
  AutomationForm: AutomationFormPage,
  CheckoutPlus: CheckoutPlusSettingsPage,
  CheckoutWidget: CheckoutWidgetSettingsPage,
  Tags: TagSettingsPage,
  CustomFields: CustomFieldSettingsPage,
  Metafields: MetafieldSettingsPage,
  Developer: DeveloperSettingsPage,
  WebhookDeliveries: WebhookDeliveriesPage,
  Email: EmailSettingsPage,
  Integrations: IntegrationsSettingsPage,
  Notifications: NotificationsSettingsPage,
  OrderEditing: OrderEditingSettingsPage,
  ProductGroups: ProductGroupSettingsPage,
  Reasons: ClaimReasonSettingsPage,
  Registrations: RegistrationSettingsPage,
  Returns: ReturnsSettingsPage,
  ShippingClaims: ShippingProtectionSettingsPage,
  ShippingPolicies: ShippingPolicySettingsPage,
  ShippingPlus: ShippingPlusSettingsPage,
  TestDrive: TestDriveSettingsPage,
  Theme: ThemeSettingsPage,
  Tracking: TrackingSettingsPage,
  Users: UserSettingsPage,
  Warranties: WarrantiesSettingsPage,
  Discounts: DiscountDefinitionSettingsPage,
  DataExport: DataExportSettingsPage,
  DataExportForm: DataExportSettingsFormPage,
};
